import React, { Suspense, lazy } from "react";
import {
  Redirect,
  Route,
  Switch,
  useHistory,
  useLocation,
  useRouteMatch,
} from "react-router-dom";
import { Tabs } from "antd";

import SkeletonBlock from "commons/Skeleton/SkeletonBlock";

import "../Account.css";
import "../setting.css";

const { TabPane } = Tabs;

// Shared importer refs so hover-prefetch and lazy() resolve the same module
// promise (webpack dedupes), warming the chunk before the user clicks.
const importers = {
  personal: () => import("./PersonalSettingsPage"),
  billing: () => import("./BillingSettingsPage"),
  organization: () => import("./OrganizationSettingsPage"),
  users: () => import("./UsersSettingsPage"),
};

const PersonalSettingsPage = lazy(importers.personal);
const BillingSettingsPage = lazy(importers.billing);
const OrganizationSettingsPage = lazy(importers.organization);
const UsersSettingsPage = lazy(importers.users);

const tabs = [
  { key: "personal", label: "Personal" },
  { key: "billing", label: "Billing" },
  { key: "organization", label: "Organization" },
  { key: "users", label: "Users" },
];

const SettingsLayout = () => {
  const { path, url } = useRouteMatch();
  const history = useHistory();
  const location = useLocation();

  const activeKey =
    tabs.find((tab) => location.pathname.startsWith(`${url}/${tab.key}`))?.key ||
    "personal";

  const routedContent = (
    <Suspense
      fallback={
        <div style={{ paddingTop: 20 }}>
          <SkeletonBlock style={{ height: 40, width: "100%", margin: 0 }} />
        </div>
      }
    >
      <Switch>
        <Route path={`${path}/personal`} component={PersonalSettingsPage} />
        <Route path={`${path}/billing`} component={BillingSettingsPage} />
        <Route
          path={`${path}/organization`}
          component={OrganizationSettingsPage}
        />
        <Route path={`${path}/users`} component={UsersSettingsPage} />
        <Redirect to={`${url}/personal`} />
      </Switch>
    </Suspense>
  );

  return (
    <div className="settings-page">
      <Tabs
        className="setting-table setting-table-tab"
        centered
        type="card"
        activeKey={activeKey}
        onChange={(key) => history.push(`${url}/${key}`)}
      >
        {tabs.map((tab) => (
          <TabPane
            key={tab.key}
            tab={
              <span
                onMouseEnter={() => importers[tab.key]()}
                onFocus={() => importers[tab.key]()}
              >
                {tab.label}
              </span>
            }
          >
            {/* Only the active pane renders the router, so the routed page
                mounts once inside the antd content holder (visually joined
                to its tab) instead of below the tab bar. */}
            {tab.key === activeKey && routedContent}
          </TabPane>
        ))}
      </Tabs>
    </div>
  );
};

export default SettingsLayout;
